import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ScheduleDemoPage = () => {
  useEffect(() => {
    // Wait for Calendly to be available, then initialize the widget
    const initCalendly = () => {
      if (window.Calendly) {
        window.Calendly.initInlineWidget({
          url: 'https://calendly.com/asha-sales/demo?hide_gdpr_banner=1',
          parentElement: document.getElementById('calendly-container'),
        });
      } else {
        // If Calendly isn't loaded yet, try again in 100ms
        setTimeout(initCalendly, 100);
      }
    };

    initCalendly();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-24 pb-20 px-6">
        <div className="container mx-auto max-w-5xl">
          <div className="text-center mb-3">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
              Schedule Your Demo
            </h1>
            <p className="text-lg text-gray-600">
              Select a time that works best for you to see Asha in action.
            </p>
          </div>
          
          <div 
            id="calendly-container"
            style={{ minWidth: '320px', height: '700px' }} 
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ScheduleDemoPage;
